import React, { useEffect, useState } from 'react';
import { Grid, Box, Modal, Typography, Button, LinearProgress } from "@mui/material";
import { styles } from "./styles";
import CloseIcon from '@mui/icons-material/Close';
import { deleteUser } from 'apis/user';

interface DeleteUserProps {
  open: boolean;
  handleClose: Function | any;
  user: { name: string, id: number } | null;
  getUsers: Function;
}


const DeleteUserModal: React.FC<DeleteUserProps> = ({ open, handleClose, user, getUsers }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState("");

  const handleDeleteUser = async () => {
    setErr("");
    setIsLoading(true);
    console.log(user);
    if (user !== null) {
      let data = await deleteUser(user.id);
      if (data) {
        setIsLoading(false);
        handleClose(false);
        getUsers();
      }
      if (data?.response?.data?.errorMessage) {
        setIsLoading(false);
        setErr(data.response.data.errorMessage);
      }
    } else {
      setIsLoading(false);
      handleClose(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <>
        <Box sx={styles.container}>
          {isLoading && <LinearProgress sx={{ margin: ".5rem 0" }} />}
          {err !== "" && <Typography sx={{color: "red", fontSize: ".7rem"}}>{err}</Typography>}
          <Grid item xs={12} sx={styles.header}>
            <h2>Delete User</h2>
            <CloseIcon onClick={() => handleClose(false)} />
          </Grid>
          <Grid item xs={12}>
            <Typography>Are you sure you want to delete user {user !== null && user.name}?</Typography>
          </Grid>

          <Grid item xs={12} sx={styles.buttonContainer}>
            <Button sx={styles.cancelButton} onClick={() => handleClose(false)}>No</Button>
            <Button sx={styles.addButton} onClick={() => handleDeleteUser()}>Yes</Button>
          </Grid>
        </Box>
      </>
    </Modal>
  )
}

export default DeleteUserModal;
